import React, { useState } from "react";
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogFooter,
} from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { AlertTriangle } from "lucide-react";
import { RUNBOOK } from "@/constants/testIds";

export default function DeleteRunbookDialog({ open, onOpenChange, runbookTitle, onConfirm, loading }) {
  const [text, setText] = useState("");
  const canDelete = text.trim().toUpperCase() === "DELETE";

  const handleOpenChange = (v) => {
    if (!v) setText("");
    onOpenChange(v);
  };

  return (
    <AlertDialog open={open} onOpenChange={handleOpenChange}>
      <AlertDialogContent data-testid={RUNBOOK.deleteDialog} className="bg-popover">
        <AlertDialogHeader>
          <div className="flex items-center gap-2 text-red-500">
            <AlertTriangle className="h-5 w-5" />
            <AlertDialogTitle>Delete this runbook?</AlertDialogTitle>
          </div>
          <AlertDialogDescription className="pt-1">
            You are about to permanently delete <span className="font-semibold text-foreground">"{runbookTitle}"</span>.
            This can't be undone. Type <span className="font-mono font-semibold text-foreground">DELETE</span> to confirm.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <div className="space-y-2 py-2">
          <Label htmlFor="delete-confirm">Confirmation</Label>
          <Input
            id="delete-confirm"
            data-testid={RUNBOOK.deleteConfirmInput}
            value={text}
            onChange={(e) => setText(e.target.value)}
            placeholder="Type DELETE"
            autoComplete="off"
          />
        </div>
        <AlertDialogFooter>
          <Button variant="outline" onClick={() => handleOpenChange(false)} data-testid={RUNBOOK.deleteCancelBtn}>
            Cancel
          </Button>
          <Button
            variant="destructive"
            disabled={!canDelete || loading}
            onClick={onConfirm}
            data-testid={RUNBOOK.deleteConfirmBtn}
          >
            {loading ? "Deleting…" : "Delete runbook"}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
